export default __webpack_public_path__ + "static/media/Scissors_img.4d6a4442.png";